import {
    useState,
    type FC
} from "react";
import {
    Animated,
    View
} from "react-native";
import type IBadgeFadeProps from "./type";
import type {
    BadgeFadeHolder
} from "./type";
import stylesheet from "./stylesheet";
import {
    useAnimatedState
} from "../../../../helpers/motion";
import Text from "../../../text";

const BadgeFade: FC<IBadgeFadeProps> = ({
    customTheme,
    titleStyle,
    variant,
    color,
    title
}) => {
    const [
        holder,
        setHolder
    ] = useState<BadgeFadeHolder>({
        previous: null,
        count: 0,
        title
    });

    if(holder.title !== title) {
        setHolder({
            count: holder.count + 1,
            previous: holder.title,
            title
        });
    }

    const progress = useAnimatedState({
        onFinish: () => setHolder((current) => ({
            ...current,
            previous: null
        })),
        isNativeDriverEnabled: false,
        intent: "contentSwap",
        value: holder.count,
        customTheme
    });

    const previousOpacity = progress.interpolate({
        inputRange: [
            holder.count - 1,
            holder.count - 0.4
        ],
        extrapolate: "clamp",
        outputRange: [
            1,
            0
        ]
    });

    const currentOpacity = progress.interpolate({
        inputRange: [
            holder.count - 1,
            holder.count - 0.76,
            holder.count
        ],
        extrapolate: "clamp",
        outputRange: [
            0,
            0,
            1
        ]
    });

    const renderText = (value: string) => <Text
        customTheme={customTheme}
        customColor={color}
        style={titleStyle}
        variant={variant}
        numberOfLines={1}
    >
        {value}
    </Text>;

    return <View
        style={stylesheet.container}
    >
        {
            holder.previous ?
                <Animated.View
                    style={[
                        stylesheet.previous,
                        {
                            opacity: previousOpacity
                        }
                    ]}
                    aria-hidden={true}
                >
                    {renderText(holder.previous)}
                </Animated.View>
            :
                null
        }
        <Animated.View
            style={[
                stylesheet.current,
                {
                    opacity: holder.count ? currentOpacity : 1
                }
            ]}
        >
            {renderText(title)}
        </Animated.View>
    </View>;
};
export default BadgeFade;
